shadow$provide[195] = function(require,module,exports) {
var require$_DOT__SLASH_camera_DOT_js = require("./camera.js");
require.exportCopy(module, require$_DOT__SLASH_camera_DOT_js);

};